import React from "react";

import colors from "core/colors";

const MobileIconSvg = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            title="Icons"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.000244141 0H9.51338V9.51313H0.000244141V0ZM9.13003 14C11.8626 14 14.0778 11.7848 14.0778 9.05228C14.0778 6.31973 11.8626 4.10455 9.13003 4.10455C6.39748 4.10455 4.18231 6.31973 4.18231 9.05228C4.18231 11.7848 6.39748 14 9.13003 14Z"
                fill={colors.fossil}
            />
        </svg>
    );
};

export default MobileIconSvg;
